import PropTypes from 'prop-types';
import React from 'react';
import styles from './Table.css?module';
import cx from 'classnames';

class Table extends React.Component {
  render() {
    const {
      numberOfColumns,
      numberOfRows,
      maxRows,
      getHeaderStyleAt,
      getHeaderAt,
      getCellStyleAt,
      getCellAt,
      style,
      darkMode,
    } = this.props;

    const columnCount = numberOfColumns();
    const rowCount = Math.min(numberOfRows(), maxRows);
    let row = null;
    const headers = [];
    const rows = [];

    for (let i = 0; i < columnCount; i++) {
      headers.push(
        <th
          className={styles.headerCell}
          key={`header:${i}`}
          style={getHeaderStyleAt(i)}
        >
          {getHeaderAt(i)}
        </th>
      );
    }

    for (let j = 0; j < rowCount; j++) {
      row = [];
      for (let k = 0; k < columnCount; k++) {
        row.push(
          <td
            className={styles.cell}
            style={getCellStyleAt(j, k)}
            key={`row:${j}:column:${k}`}
          >
            {getCellAt(j, k)}
          </td>
        );
      }
      rows.push(
        <tr className={styles.row} key={`row:${j}`}>
          {row}
        </tr>
      );
    }

    return (
      <table
        className={cx(styles.table, darkMode ? styles.darkMode : '')}
        style={style}
      >
        <thead className={styles.header}>
          <tr>{headers}</tr>
        </thead>
        <tbody>{rows}</tbody>
      </table>
    );
  }
}

Table.defaultProps = {
  maxRows: 200,
  style: {},
  getCellStyleAt: () => null,
  getHeaderStyleAt: () => null,
};

Table.propTypes = {
  numberOfRows: PropTypes.func.isRequired,
  numberOfColumns: PropTypes.func.isRequired,
  getHeaderAt: PropTypes.func.isRequired,
  getHeaderStyleAt: PropTypes.func.isRequired,
  getCellAt: PropTypes.func.isRequired,
  getCellStyleAt: PropTypes.func.isRequired,
  maxRows: PropTypes.number.isRequired,
  style: PropTypes.object,
};

export default Table;
